import request from '@/request/request'

// 查询菜单树
export function menuTree() {
    return request({
        url: '/api/permission/menu/treeselect',
        method: 'get'
    })
}

// 根据角色id查询菜单树
export function getMenuTreeByRole(roleId) {
    return request({
        url: '/api/permission/menu/roleMenuTreeselect/' + roleId,
        method: 'get'
    })
}


